import axios, { AxiosResponse } from 'axios'
import Api from './Api'
import { Vm } from '@/main';
import { Store } from './Store';

class OrderRepository {  
    culture: () => string;
    
    constructor() {
        this.culture = () => (localStorage.getItem("culture") ? localStorage.getItem("culture") : "nl-BE") as string;
    }


    public async getOrderInfo(orderId : string | null): Promise<IOrderInfo> {
        if (navigator.onLine) {
            try {
                var res = await Api.getData("Order/GetOrderInfo?id=" + orderId);

                if (res.status == 200)
                    return res.data;

            } catch {
                return {} as IOrderInfo;
            }
        } else {
            return {} as IOrderInfo;
        }

        return {} as IOrderInfo;
    }
}

export interface IOrderInfo {
    code: string | undefined;
    id: string;
    status: string; 
    routeId : string;
}

export const OrderRepo = new OrderRepository();